import { Pipe, PipeTransform } from '@angular/core';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Pipe({
  name: 'sortPipe'
})
export class SortPipe implements PipeTransform {

  transform(options: Array<any>): Array<any> {
    return options.sort((leftside, rightside): number => {
      if (leftside.text.toLowerCase() < rightside.text.toLowerCase()) {
        return -1;
      }
      if (leftside.text.toLowerCase() > rightside.text.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/pipes/sort.pipe.ts